module.exports = __webpack_public_path__ + "img/talk.ab3b57b4.svg";